export enum AwardProcessType {
    AutoProcessedOnAcceptance = 1,
    ManuallyProcessed = 2,
}